import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=4333bcd2&"
import script from "./companies.vue?vue&type=script&lang=ts&"
export * from "./companies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports